import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { AdmService } from 'src/app/service/adm.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { Globals } from 'src/app/globals';

// PDF export
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';

// Excel sheet export
import { Cell, Workbook } from 'exceljs';
import * as fs from 'file-saver';
import { SystemService } from 'src/app/service/system.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';

declare var $: any;

@Component({
  selector: 'app-new-candidate-inquiry',
  templateUrl: './new-candidate-inquiry.component.html',
  styleUrls: ['./new-candidate-inquiry.component.scss']
})
export class NewCandidateInquiryComponent implements OnInit {

  showLoader: boolean = false;
  candidateInquiriesData: any;
  photoPath: any = `${environment.API_URL_UTIL}/api/downloadFile/`;
  exporting = false;
  appStatues: any;
  allProvinces: any;
  dataTable: any;
  excelHeaderName: any;
  excelExportColumnsOption: any;
  dropdownSettings: any = {};
  ShowFilter = true;
  limitSelection = false;
  exportColumnsSelected: any;
  // imageUrl: any = "https://gravatar.com/avatar/ae4e3e608c9496ff0a04d46b0304cbe8?s=400&d=robohash&r=x";
  @ViewChild('pdfPage') pdfPage: any;

  filterVaild = new FormGroup({

    evalStartDate: new FormControl('', [
      Validators.required,
    ]),
    evalEndDate: new FormControl('', [
      Validators.required,
    ]),
  });

  constructor(private admService: AdmService, private systemService: SystemService, private toastrService: ToastrService,
    public translate: TranslateService, public router: Router, public globals: Globals, public datepipe: DatePipe) { }

  ngOnInit(): void {
    // Test data
    // this.candidateInquiriesData = [
    //   {
    //     id: 1,
    //     full_name_en: "candidate1",
    //     photo_filename: "candidate photo",
    //     nid_no: "candidate national id",
    //     address_provinceid: "candidate province",
    //     bachlor_score: "candidate score",
    //     acceptance_status: "candidate status"
    //   },
    //   {
    //     id: 2,
    //     full_name_en: "candidate2",
    //     photo_filename: "candidate photo2",
    //     nid_no: "candidate national id2",
    //     address_provinceid: "candidate province2",
    //     bachlor_score: "candidate score2",
    //     acceptance_status: "candidate status2"
    //   }
    // ];
    // this.updateTable();
    this.getAppStatuses();

    // Listen for language change to update table
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateTable();
      this.initMultiSelectDropdown();
    });

    this.initMultiSelectDropdown();

  }

  getAllNewCandidateInquiry() {
    let candId = 0;
    if (typeof this.globals.candidateId != undefined && this.globals.candidateId != null && this.globals.candidateId != 0) {
      candId = this.globals.candidateId;
    }

    this.admService.getAllAdmCands().subscribe(
      // this.admService.getCandidateInquiries(candId).subscribe(
      // this.admService.getCandidateInquiriesByCurrentUserName(this.globals.currentUserInfo.username).subscribe(
      data => {
        this.candidateInquiriesData = data;
        // this.candidateInquiriesData = data.map((cand: any) => {
        //   // console.log(cand.addressProvinceid);
        //   let statusId = cand.appstatusid;
        //   let addressProvinceid = cand.addressProvinceid;
        //   cand.appStatusNameAr = "";
        //   cand.appStatusNameEn = "";
        //   if (typeof statusId != 'undefined' && statusId > 0) {
        //     let getAppStatus = this.appStatues.filter((i: any) => i.id == statusId)[0];
        //     if (typeof getAppStatus != 'undefined') {
        //       cand.appStatusNameAr = getAppStatus.appStatusNameAr;
        //       cand.appStatusNameEn = getAppStatus.appStatusNameEn;
        //     }
        //   }
        //   if (typeof addressProvinceid != 'undefined' && addressProvinceid > 0) {
        //     let getProv = this.allProvinces.filter((i: any) => i.id == addressProvinceid)[0];
        //     if (typeof getProv != 'undefined') {
        //       cand.provNameAr = getProv.provinceNameAr;
        //       cand.provNameEn = getProv.provinceNameEn;
        //     }
        //   }
        //   return cand;
        // });
        this.showLoader = false;
        this.updateTable();
      },
      error => {
        this.updateTable();
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_CAND_INQUIRES"));
        this.showLoader = false;
      }
    );
  }

  getAdmCandidateByInviteDates(startDate: string, endDate: string) {

    this.admService.getAdmCandidateByInviteDates(startDate, endDate).subscribe(
      data => {
        this.candidateInquiriesData = data;
        this.showLoader = false;
        this.updateTable();
      },
      error => {
        this.updateTable();
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_CAND_INQUIRES"));
        this.showLoader = false;
      }
    );
  }

  updateTable() {
    $("#datatable").DataTable().destroy();
    $("#datatable .filters").remove();
    setTimeout(() => {
      $('#datatable thead tr')
        .clone(true)
        .addClass('filters')
        .appendTo('#datatable thead');

      this.dataTable = $("#datatable").DataTable({
        // dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        "columnDefs": [
          //  { "orderable": false, "targets": [7, 8, 9, 10, 11] }
          // { targets: [1, 3, 5, 6], searchable: true },
          { targets: [1, 2, 4, 5, 6, 7, 8, 9, 10], searchable: true },
          { targets: '_all', searchable: false }
        ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        // searching: false,
        searching: true,
        search: {
          searchPlaceholder: this.translate.instant("SEARCH"),
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: this.translate.instant("SEARCH"),
        },
        // Filter params start
        orderCellsTop: true,
        fixedHeader: true,
        initComplete: function () {
          var api = this.api();

          // For each column
          api
            .columns()
            .eq(0)
            .each(function (colIdx: any) {
              // Set the header cell to contain the input element
              var cell = $('.filters th').eq(
                $(api.column(colIdx).header()).index()
              );
              $(cell).css({ "padding-left": "2px", "padding-right": "2px" });
              // $(cell).addClass("form-control");
              let filterExcludeColumn = [0, 3, 11, 12, 13, 14, 15];
              if (!filterExcludeColumn.includes(colIdx)) {

                var title = $(cell).text();
                $(cell).html('<input type="text" class="form-control" placeholder="' + title + '" />');
                // $(cell).html('<input type="text" class="form-control" placeholder="' + title + '" />');

                // On every keypress in this input
                $(
                  'input',
                  $('.filters th').eq($(api.column(colIdx).header()).index())
                )
                  .off('keyup change')
                  .on('keyup change', function (e: any) {
                    e.stopPropagation();

                    // Get the search value
                    $(e.target).attr('title', $(e.target).val());
                    var regexr = '({search})'; //$(this).parents('th').find('select').val();

                    var cursorPosition = e.target.selectionStart;
                    // Search the column for that value
                    if (colIdx == 6) {
                      api
                        .column(colIdx)
                        .search(
                          e.target.value != ''
                            ? regexr.replace('{search}', '(((^' + e.target.value + ')))')
                            : '',
                          e.target.value != '',
                          e.target.value == ''
                        )
                        .draw();
                    } else {
                      api
                        .column(colIdx)
                        .search(
                          e.target.value != ''
                            ? regexr.replace('{search}', '(((' + e.target.value + ')))')
                            : '',
                          e.target.value != '',
                          e.target.value == ''
                        )
                        .draw();
                    }

                    $(e.target)
                      .focus()[0]
                      .setSelectionRange(cursorPosition, cursorPosition);
                  });
              } else {
                $(cell).html('');
              }
            });
        },

        // Filter params end
        // buttons: [
        //   'excel', 'pdf'
        // ]
        // buttons: [{
        //   extend: 'csvHtml5',
        //   text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
        //   titleAttr: 'CSV',
        //   exportOptions: {
        //     columns: [0, 1, 3, 4, 5, 6]
        //   }
        // },
        // {
        //   extend: 'pdfHtml5',
        //   text: '<span style="font-size: 3em; color: #e04006;"><i class="fas fa-file-pdf fa-sm"></i></span>',
        //   titleAttr: 'PDF',
        //   exportOptions: {
        //     columns: [0, 1, 3, 4, 5, 6]
        //   }
        // }]
      });
    }, 1);

  }

  moodleTestResults(candidateId: number) {
    this.router.navigate(['/admission/english-test'],
      { queryParams: { candId: candidateId } });
  }

  personalInterview(candidateId: number) {
    this.router.navigate(['/admission/personal-interview'],
      { queryParams: { candId: candidateId } });
  }

  medicalCheck(candidateId: number) {
    this.router.navigate(['/admission/medical-check'],
      { queryParams: { candId: candidateId } });
  }

  evaluation(candidateId: number) {
    this.router.navigate(['/admission/evaluate'],
      { queryParams: { candId: candidateId } });
  }

  Preview(candidateId: number) {
    this.router.navigate(['/admission/cand-preview'],
      { queryParams: { candId: candidateId } });
  }

  getAppStatuses() {
    this.showLoader = true;
    this.admService.getAppStatuses().subscribe(
      data => {
        this.appStatues = data;
        this.getAllProvinces();
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_APP_STATUSES"));
        this.showLoader = false;
      })
  }

  getAllProvinces() {
    this.systemService.getAllProvincies().subscribe(
      data => {
        this.allProvinces = data;
        this.getAllNewCandidateInquiry()
      },
      error => {
        this.toastrService.error(this.translate.instant("CAN_NOT_GET_PROVINCES"));
        this.showLoader = false;
      })
  }

  htmltoPDF() {
    // parentdiv is the html element which has to be converted to PDF
    const pdfPage = this.pdfPage.nativeElement;
    console.log(pdfPage);
    html2canvas(pdfPage).then(canvas => {
      console.log(canvas.width);
      console.log(canvas.height);
      var pdf = new jsPDF('p', 'pt', [canvas.width, canvas.height]);

      var imgData = canvas.toDataURL("image/jpeg", 1.0);
      pdf.addImage(imgData, 0, 0, canvas.width, canvas.height);
      pdf.save('converteddoc.pdf');

    });

  }

  downloadPDF() {

    // var node = document.getElementById('parentdiv');
    var node = this.pdfPage.nativeElement;

    var img: any;
    var filename: any;
    var newImage: any;


    domtoimage.toPng(node, { bgcolor: '#fff', quality: 0.95 })

      .then(function (dataUrl: any) {

        img = new Image();
        img.src = dataUrl;
        newImage = img.src;

        img.onload = function () {

          var pdfWidth = img.width;
          var pdfHeight = img.height;

          // FileSaver.saveAs(dataUrl, 'my-pdfimage.png'); // Save as Image

          var doc;

          if (pdfWidth > pdfHeight) {
            doc = new jsPDF('l', 'px', [pdfWidth, pdfHeight]);
          }
          else {
            doc = new jsPDF('p', 'px', [pdfWidth, pdfHeight]);
          }


          var width = doc.internal.pageSize.getWidth();
          var height = doc.internal.pageSize.getHeight();


          doc.addImage(newImage, 'PNG', 10, 10, width, height);
          filename = 'mypdf_' + '.pdf';
          doc.save(filename);

        };


      })
      .catch(function (error: any) {
        console.log(error);
        // Error Handling

      });
  }

  testJsPdf() {
    let pdf = new jsPDF('p', 'pt', 'a4');
    pdf.html(this.pdfPage.nativeElement, {
      callback: (pdf) => {
        pdf.save("test.pdf");
      }
    });

  }

  // Excel sheet
  async generateExcel() {

    let exportIndexes: any;
    let exportIndexesOrderByHeader: any = [];

    if (typeof this.exportColumnsSelected != 'undefined' && this.exportColumnsSelected?.length > 0) {

      exportIndexes = this.exportColumnsSelected.map((el: any) => el.item_id);
    }

    // Image propability excel columns
    const imagePropabilityExcelColumns = ['A', 'B', 'C', 'D', 'E', 'F'];
    // Excel Title, Header, Data
    const title = 'Yearly Social Sharing Education For Betterment';
    let header = this.excelHeaderName;
    if (exportIndexes?.length > 0) {
      header = this.excelHeaderName.filter((el: any, index: any) => {
        if (exportIndexes.includes(index + 1)) {
          exportIndexesOrderByHeader.push(index + 1);
        }
        return exportIndexes.includes(index + 1);
      });
    }

    // const data = this.candidateInquiriesData;
    const data = this.getFilterData();

    // Create workbook and worksheet
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Inquiry sheet');

    // Add Row and formatting
    // const titleRow = worksheet.addRow([title]);
    // titleRow.font = {
    //   name: 'Corbel',
    //   family: 4,
    //   size: 16,
    //   underline: 'double',
    //   bold: true
    // };

    // worksheet.addRow([]);
    // const subTitleRow = worksheet.addRow(['Date : 06-09-2020']);

    // worksheet.mergeCells('A1:D2');

    // Blank Row
    // worksheet.addRow([]);

    // Add Header Row
    const headerRow = worksheet.addRow(header);

    // Cell Style : Fill and Border
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        // bgColor: { argb: 'FF0000FF' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });
    // const imageId1 = workbook.addImage({
    //   filename:
    //     'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   extension: 'jpeg'
    // });
    //worksheet.addImage(imageId1, 'G6:H8');
    // Add Data and Conditional Formatting
    let imageOptionIndexAtDropdown = 6;
    let imageColumnName = '';

    data.forEach((d: any) => {
      let imageBase64 = d.imageBase64;
      let imageId1 = workbook.addImage({
        // buffer: fs.readFileSync(
        //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
        // ),
        base64: imageBase64,
        extension: 'png'
      });
      // worksheet.addImage(imageId1, 'G20:H22');
      // d[6] = imageId1;
      // worksheet.addImage(imageId1, 'G20:H22');
      let rowData = [
        d.yearid,
        d.semesterid,
        d.candid,
        d.candCode,
        (this.globals.lang == 'ar') ? d.fullNameAr : d.fullNameEn,
        "",
        d.emailAddress1,
        (d.gender == "M") ? this.translate.instant("MALE") : this.translate.instant("FEMALE"),
        d.nidNo,
        this.datepipe.transform(d.dob, 'yyyy-MM-dd'),
        d.personalMob1,
        d.emergencyMob1,
        d.emergencyContact1,
        d.homeTel,
        (this.globals.lang == 'ar') ? d.maritalStatusAr : d.maritalStatusEn,
        (this.globals.lang == 'ar') ? d.militaryStatusAr : d.militaryStatusEn,
        (this.globals.lang == 'ar') ? d.nationalityAr : d.nationalityEn,
        (this.globals.lang == 'ar') ? d.addressCountryAr : d.addressCountryEn,
        (this.globals.lang == 'ar') ? d.addressRegionAr : d.addressRegionEn,
        (this.globals.lang == 'ar') ? d.addressProvinceAr : d.addressProvinceEn,
        (this.globals.lang == 'ar') ? d.addressCityAr : d.addressCityEn,
        (this.globals.lang == 'ar') ? d.addressL1Ar : d.addressL1Ar,
        (this.globals.lang == 'ar') ? d.statusAr : d.statusEn,
        (this.globals.lang == 'ar') ? d.candNotesAr : d.candNotesEn,
        (this.globals.lang == 'ar') ? d.livewithAr : d.livewithEn,
        d.livewithOther,
        d.relative1Mob,
        d.relative2Mob,
        d.relation1,
        d.relation2,
        d.siblingsCount,
        d.candSiblingsRank,
        d.thanawyaScore,
        d.thanawyaPercent + "%",
        d.termsAccepted,
        this.datepipe.transform(d.termsAcceptedOn, 'yyyy-MM-dd h:mm:ss a'),
        this.datepipe.transform(d.verificationDate, 'yyyy-MM-dd h:mm:ss a'),
        d.verifiedBy,
        this.datepipe.transform(d.invitationDate, 'yyyy-MM-dd h:mm:ss a'),
        d.invitationBy,
        d.invitationBatch,
        d.languageThanaweya,
        d.languageCefr,
        d.languageRn,
        this.datepipe.transform(d.interviewDate, 'yyyy-MM-dd h:mm:ss a'),
        d.interviewBy,
        d.interviewComment,
        d.interviewRscore,
        d.interviewWritingRscore,
        d.interviewWritingComment,
        d.interviewAttitudeRscore,
        d.interviewAttitudeComment,
        this.datepipe.transform(d.medicalDate, 'yyyy-MM-dd h:mm:ss a'),
        d.medicalBy,
        d.medicalStatus,
        d.medicalComment,
        this.datepipe.transform(d.evaluationDate, 'yyyy-MM-dd h:mm:ss a'),
        d.evaluationBy,
        d.evaluationStatus,
        d.evaluationComment,
      ]

      if (exportIndexes?.length > 0) {
        rowData = rowData.filter((el: any, index: any) => {
          return exportIndexes.includes(index + 1);
        });

        const row = worksheet.addRow(rowData);
        row.height = 100;

        if (exportIndexes.includes(imageOptionIndexAtDropdown)) {
          let imageIndex = exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown);
          worksheet.addImage(imageId1, imagePropabilityExcelColumns[imageIndex] + (2 + imageId1) + ':' + imagePropabilityExcelColumns[imageIndex] + (2 + imageId1));
        }
      } else {
        const row = worksheet.addRow(rowData);
        row.height = 100;
        worksheet.addImage(imageId1, 'F' + (2 + imageId1) + ':F' + (2 + imageId1));
      }
      // let qty: any;
      // qty = row.getCell(5);
      // as Cell | undefined
      // let color = 'FF99FF99';
      // if (+qty.value < 500) {
      //   color = 'FF9999';
      // }

      // qty.fill = {
      //   type: 'pattern',
      //   pattern: 'solid',
      //   fgColor: { argb: color }
      // };
    });

    // worksheet.getColumn(3).width = 30;
    // worksheet.getColumn(4).width = 30;
    if (exportIndexes?.length > 0 && exportIndexes.includes(imageOptionIndexAtDropdown)) {
      worksheet.getColumn(exportIndexesOrderByHeader.indexOf(imageOptionIndexAtDropdown) + 1).width = 20;
    } else {
      worksheet.getColumn(6).width = 20;
    }
    // worksheet.addRow([]);

    //     let workbook2 = Excel.stream.xlsx.WorkbookWriter()
    // workbook2.media.push({
    //     filename: './Picture1.png',
    //     extension: 'png',
    //   })
    // worksheet.addImage(0, 'B1:E6')

    // Ali
    // const logoBase64 =
    //   'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAfQAAAFKCAMAAADcyF29AAABxVBMVEVHcEwJCAggFxEBAQE2KyQAAAA0LScAAAAAAAA1LysXEQ0EBAQFBAMDAwMLCQgGBQUFBAOEQhUHBwZjQSuScFoVFRZvNAx5NghcOyaudU8yMDBrNhOiViMZFhXEdD3Ef0+4ZzFISUdSJwliMA6BPA6lVR8CAgEDAgQPDhANDgsKCQoVFhPObi4SERS2VxcE.......';
    //
    // const readFileInNode = (filename) => {
    //   console.log('readFileInNode - fs', fs)
    //   console.log('readFileInNode - fsMod', fsMod)
    //   return new Promise((resolve, reject) => fs.readFile(filename, 'utf8', (err, data) => err ? reject(err) : resolve(data)))
    // }
    //Test base 64 image 
    // let image = document.createElement('img');
    // image.width = 10;
    // image.height = 10;
    // image.src = "https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png";
    //end
    // console.log(this.myImage.nativeElement);
    // add image to workbook by buffer
    // const imageId1 = workbook.addImage({
    //   // buffer: fs.readFileSync(
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png'
    //   // ),
    //   base64: this.getDataUrl(this.myImage.nativeElement),
    //   extension: 'png'
    // });

    // const imageId1 = workbook.addImage({
    //   // filename:
    //   //   'https://www.imgonline.com.ua/examples/jpeg-artifacts-improved_3x.png',
    //   base64: logoBase64,
    //   extension: 'png'
    // });
    // worksheet.addImage(imageId1, 'G20:H22');
    // Footer Row
    // const footerRow = worksheet.addRow([
    //   'This is system generated excel sheet.'
    // ]);
    // footerRow.getCell(1).fill = {
    //   type: 'pattern',
    //   pattern: 'solid',
    //   fgColor: { argb: 'FFCCFFE5' }
    // };
    // footerRow.getCell(1).border = {
    //   top: { style: 'thin' },
    //   left: { style: 'thin' },
    //   bottom: { style: 'thin' },
    //   right: { style: 'thin' }
    // };

    // Merge Cells
    // worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

    // Generate Excel File with given name
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], {
        type:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      fs.saveAs(blob, 'Inquiry.xlsx');
    });
  }

  getBase64(event: any, index: number) {
    let img = event.target;
    let dataURL: any;
    var canvas = document.createElement('canvas');
    let ctx: any;
    ctx = canvas.getContext('2d');
    // canvas.height = img.height;
    // canvas.width = img.width;

    // canvas.height = img.clientHeight;
    // canvas.width = img.clientWidth;

    canvas.height = img.naturalHeight;
    canvas.width = img.naturalWidth;
    // let newWidth = 100;
    // let newHeight = 100;
    ctx.drawImage(img, 0, 0);
    // ctx.drawImage(img, 0, 0);
    dataURL = canvas.toDataURL('image/jpeg');
    this.candidateInquiriesData[index].imageBase64 = dataURL;
    // console.log("test func: ");
    // console.log(dataURL);
    // console.log("data: ");
    // console.log(this.data);
  }

  checkUserStatusAccept(candStatus: number) {
    // return (candStatus >= 27 && candStatus != 70)
    return (candStatus >= 27)
  }

  checkUserEvalutionAccept(candStatus: number) {
    return (candStatus >= 55)
  }
  filterChange() {

  }
  filterSubmit() {
    if (this.filterVaild.valid) {
      let startDate = this.filterVaild.controls.evalStartDate.value;
      let endDate = this.filterVaild.controls.evalEndDate.value;
      this.getAdmCandidateByInviteDates(startDate, endDate);
    } else {
      this.filterVaild.markAllAsTouched();
      this.filterVaild.markAsDirty();
    }
  }

  getFilterData() {
    let dataTableRows = this.dataTable.rows({ order: 'index', search: 'applied' }).data();
    let filterIds: any = [];
    let filteredData = this.candidateInquiriesData;
    if (dataTableRows && dataTableRows.length > 0) {
      for (let element in dataTableRows) {
        if (element <= dataTableRows.length) {
          filterIds.push(dataTableRows[element][0]);
        }
      }
      filteredData = this.candidateInquiriesData.filter((el: any) => {
        return filterIds.includes(el.candid.toString());
      });
    }

    return filteredData;
  }

  // Multi select dropdown start

  onItemSelect(item: any) {
    // console.log('onItemSelect', item);
  }
  onSelectAll(items: any) {
    // console.log('onSelectAll', items);
  }

  toogleShowFilter() {
    this.ShowFilter = !this.ShowFilter;
    this.dropdownSettings = Object.assign({}, this.dropdownSettings, { allowSearchFilter: this.ShowFilter });
  }

  handleLimitSelection() {
    if (this.limitSelection) {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: 2 });
    } else {
      this.dropdownSettings = Object.assign({}, this.dropdownSettings, { limitSelection: null });
    }
  }

  initMultiSelectDropdown() {
    // Multi select dropdown
    this.excelHeaderName = [
      this.translate.instant("YEAR"),
      this.translate.instant("SEMESTER"),
      this.translate.instant("ID"),
      this.translate.instant("CANDUDATE_CODE"),
      this.translate.instant("CANDIDATE_NAME"),
      this.translate.instant("CANDIDATE_PHOTO"),
      this.translate.instant("EMAIL"),
      this.translate.instant("GENDER"),
      this.translate.instant("NID"),
      this.translate.instant("DATE_OF_BIRTH"),
      this.translate.instant("PERSONAL_MOBILE_1"),
      this.translate.instant("EMERGENCY_MOBILE_1"),
      this.translate.instant("EMERGENCY_CONTACT_1"),
      this.translate.instant("HOME_TELEPHONE"),
      this.translate.instant("MARTIAL_STATUS"),
      this.translate.instant("MILITIRY_STATUS"),
      this.translate.instant("NATIONALITY"),
      this.translate.instant("COUNTRY"),
      this.translate.instant("REGION"),
      this.translate.instant("PROVINCE"),
      this.translate.instant("CITY"),
      this.translate.instant("ADDRESS"),
      this.translate.instant("APPLICATION_STATUS"),
      this.translate.instant("CAND_NOTES"),
      this.translate.instant("LIVE_WITH"),
      this.translate.instant("LIVE_WITH_OTHER"),
      this.translate.instant("RELATIVE_MOBILE_1"),
      this.translate.instant("RELATIVE_MOBILE_2"),
      this.translate.instant("RELATION_1"),
      this.translate.instant("RELATION_2"),
      this.translate.instant("SIBLINGS_COUNT"),
      this.translate.instant("CAND_SIBLINGS_RANK"),
      this.translate.instant("THANAWYA_SCORE"),
      this.translate.instant("THANAWYA_PERCENTAGE"),
      this.translate.instant("TERME_ACCEP"),
      this.translate.instant("TERME_ACCEP_DATE"),
      this.translate.instant("VERIFICATION_DATE"),
      this.translate.instant("VERIFIED_BY"),
      this.translate.instant("INVITATION_DATE"),
      this.translate.instant("INVITATION_BY"),
      this.translate.instant("INVITATION_BATCH"),
      this.translate.instant("LANGUAFE_THANAWEYA"),
      this.translate.instant("LANGUAFE_CEFR"),
      this.translate.instant("LANGUAFE_RN"),
      this.translate.instant("INTERVIEW_DATE"),
      this.translate.instant("INTERVIEW_BY"),
      this.translate.instant("INTERVIEW_COMMENT"),
      this.translate.instant("INTERVIEW_RUBRIC_SCORE"),
      this.translate.instant("INTERVIEW_WRITING_RUBRIC_SCORE"),
      this.translate.instant("INTERVIEW_WRITING_COMMENT"),
      this.translate.instant("INTERVIEW_ATTITUDE_R_SCORE"),
      this.translate.instant("INTERVIEW_ATTITUDE_COMMENT"),
      this.translate.instant("MEDICAL_CHECK_DATE"),
      this.translate.instant("MEDICAL_BY"),
      this.translate.instant("MEDICAL_CHECK_STATUS"),
      this.translate.instant("MEDICAL_CHECK_COMMENT"),
      this.translate.instant("EVALUATION_DATE"),
      this.translate.instant("EVALUATION_BY"),
      this.translate.instant("EVALUATION_STATUS"),
      this.translate.instant("EVALUATION_COMMENT")];
    this.excelExportColumnsOption = this.excelHeaderName.map((el: any, index: any) => {
      return { item_id: index + 1, item_text: el }
    });
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 4,
      allowSearchFilter: this.ShowFilter
    };
  }

  // Multi select dropdown end

}
